import { API } from '@Providers';

interface UpdateMedicalCostOnCartPayload {
  _id: string;
  animal_id: string;
  type: string;
  add_to_receipt: boolean;
}

export default async function (payload: UpdateMedicalCostOnCartPayload) {
  const endpoint = '/api/shelter/cart/update-medical-cost';

  return API({ endpoint, method: 'put', payload });
}
